import Container from '../components/common/Container';
import PageHeader from '../components/common/PageHeader';

const Settings = () => {
  return (
    <Container>
      <PageHeader title='Ayarlar' />
    </Container>
  );
};

export default Settings;
